export default __webpack_public_path__ + "static/media/logo.011c567d.svg";